/**
 * App-wide «is anything dirty?» registry. Editors register their dirty check
 * through useUnsavedChangesPrompt; non-React code (the service-worker update
 * reload in pwa.ts) consults it before doing anything that would drop
 * in-memory state.
 */
const checks = new Set<() => boolean>();

export function registerDirtyCheck(check: () => boolean): () => void {
  checks.add(check);
  return () => {
    checks.delete(check);
  };
}

export function hasUnsavedChanges(): boolean {
  for (const check of checks) if (check()) return true;
  return false;
}
